'use client';
import { StyledBrandList } from '@/components/common/ygen/sections/brand-list/brandlist.style';
import React, { useMemo } from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import reactHtmlParser from 'react-html-parser';
import Button from '@/components/common/ui/buttons/Button';
import LeftSVGScroll from '@/components/common/ui/buttons/LeftSVGScroll';
import RightSVGScroll from '@/components/common/ui/buttons/RightSVGScroll';

const BrandList = ({ data }) => {
	// Memoize the posts list to prevent unnecessary re-renders
	const posts = useMemo(() =>
			data?.posts?.list || [],
		[data?.posts?.list]
	);

	// Memoize the renderBrandItem function to prevent unnecessary re-renders
	const renderBrandItem = useMemo(() =>
			(e, index) => {
				const thumb = e?.images?.find((f) => f?.thumb === 'on');
				return (
					<section key={index} className={`brand-item-single item-brand-${index}`}>
						<Container>
							<Row>
								<Col md={3} className="brand-item-left">
									<p>{reactHtmlParser(e?.data?.title)}</p>
									<img src={e?.images?.[0]?.full_path} alt={e?.data?.title || ''} />
								</Col>
								<Col md={8} className="brand-item-right">
									<h3>{reactHtmlParser(e?.data?.subtitle)}</h3>
									{reactHtmlParser(e?.data?.description)}
									<Button
										margin="30px 0 0"
										color="#152637"
										background="#152637"
										pathColor="white"
										src={`/ready-stock?brand=${e?.data?.slug}`}
										text="Check Products"
									/>
								</Col>
							</Row>
						</Container>
						{
							index % 2 === 0 ?
							<LeftSVGScroll career/> :

								<RightSVGScroll career/>

						}
					</section>
				);
			},
		[]
	);

	return (
		<StyledBrandList className="brandlist" data-scroll-section>
			{posts.length > 0 && posts.map((e, index) => renderBrandItem(e, index))}
		</StyledBrandList>
	);
};


export default React.memo(BrandList);